<template>
  <div id="common_header">
    <header class="header">
      <title>{{ title }} - GRIT</title>
      <img
        class="header_service_logo"
        src="@assets/images/grit-logo.png"
        alt="Logo"
      />
      <div class="header_body">{{ title }}フォーム</div>
    </header>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '会員登録',
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../design/common-settings';
.header {
  position: relative;
  display: flex;
  width: 100%;
  height: 5%;
  &_service_logo {
    width: 80px;
    height: 39px;
    padding: 10px;
    margin-left: 5%;
  }
  &_body {
    margin: auto 0;
  }
}
</style>
